import React, { useEffect, useRef, useState } from "react";
import VerificationSDK from "../VerificationSDK";
import { KycModal } from "./kycModal";
import "./kycModal.css";

interface StandaloneKycPageProps {
  serverKey: string;
}

export const StandaloneKycPage: React.FC<StandaloneKycPageProps> = ({ serverKey }) => {
  const [error, setError] = useState<string | null>(null);
  const [ready, setReady] = useState(false);
  const sdkRef = useRef<VerificationSDK | null>(null);

  useEffect(() => {
    const run = async () => {
      try {
        const path = typeof window !== "undefined" ? window.location.pathname : "/";
        const match = path.match(/\/kyc-standalone\/(.*?)($|[?#\s])/i);
        const sessionIdRaw = match && match[1] ? decodeURIComponent(match[1]) : "";
        if (!sessionIdRaw) {
          setError("Missing sessionId in URL");
          return;
        }
        const sdk = new VerificationSDK({ serverKey });
        sdk.setSessionId(sessionIdRaw);
        sdkRef.current = sdk;
        setReady(true);
      } catch (e: any) {
        setError(e?.message || "Failed to initialize KYC");
      }
    };
    run();
  }, [serverKey]);

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0b0f17", color: "#fff" }}>
        <div>
          <h2 style={{ marginTop: 0 }}>KYC Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!ready || !sdkRef.current) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0b0f17", color: "#fff" }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#0b0f17" }}>
      <KycModal sdk={sdkRef.current} onClose={() => { try { window.close(); } catch {} }} />
    </div>
  );
};


